import { ref } from 'vue'

export const recordedBlob = ref<Blob>()
export const videoId = ref<string>()
